exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-layout[data-v-3cc2878e],.list-layout__list[data-v-3cc2878e],.list-layout__sort[data-v-3cc2878e]{margin-bottom:20px}.list-layout[data-v-3cc2878e]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex:1;flex:1}.list-layout__list[data-v-3cc2878e]{-ms-flex:1;flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3cc2878e","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/listlayout/ListLayout.vue
// module id = 133f59de9d76a2af1d8c
// module chunks = 0